import React, { useState, useEffect } from "react";
import { Polyline, Marker } from "react-leaflet";
import {
  categoryColors,
  getCategoryIcon,
  fetchGoogleRoute,
  decodePolyline,
} from "./mapUtils";

const PolygonLabels = ({ destinos = [], categoriaSeleccionada }) => {
  const [routeCoords, setRouteCoords] = useState([]);
  const [loadingRoute, setLoadingRoute] = useState(false);

  // 🔹 Subcategorías válidas solo para Circuitos Turísticos
  const subcategoriasValidas = ["Histórico", "Comercial"];

  // 🔹 Orden manual de los destinos (en este orden específico)
  const ordenManual = [
    "Plaza Bolognesi",
    "Psj. Unión",
    "Iglesia Matriz de Santa Catalina",
  ];

  useEffect(() => {
    // ⚠️ Solo trazar rutas si la categoría seleccionada es Circuitos Turísticos
    if (categoriaSeleccionada !== "Circuitos Turísticos") {
      setRouteCoords([]);
      return;
    }

    const getRoutes = async () => {
      setLoadingRoute(true);

      // 🔹 Filtrar destinos de Circuitos Turísticos con subcategorías válidas
      const destinosFiltrados = destinos.filter(
        (d) =>
          d.categoria === "Circuitos Turísticos" &&
          subcategoriasValidas.includes(d.subcategoria)
      );

      // 🔹 Agrupar por subcategoría (Histórico, Comercial, etc.)
      const grupos = destinosFiltrados.reduce((acc, d) => {
        if (!acc[d.subcategoria]) acc[d.subcategoria] = [];
        acc[d.subcategoria].push(d);
        return acc;
      }, {});

      const rutas = [];

      // 🔹 Procesar cada subcategoría válida
      for (const [subcat, points] of Object.entries(grupos)) {
        // Ordenar los destinos según el orden manual
        const puntosOrdenados = points.sort((a, b) => {
          const idxA = ordenManual.indexOf(a.nombre);
          const idxB = ordenManual.indexOf(b.nombre);

          // Los que no estén en la lista van al final
          if (idxA === -1 && idxB === -1) return 0;
          if (idxA === -1) return 1;
          if (idxB === -1) return -1;
          return idxA - idxB;
        });

        // Solo generar la ruta si hay al menos 2 puntos válidos
        if (puntosOrdenados.length >= 2) {
          try {
            const encodedPolyline = await fetchGoogleRoute(puntosOrdenados);
            if (encodedPolyline) {
              rutas.push({
                subcategoria: subcat,
                coords: decodePolyline(encodedPolyline),
                color: subcat === "Histórico" ? "#FF5733" : "#33C1FF", // 🎨 Colores distintos
              });
            }
          } catch (err) {
            console.error(`Error al obtener ruta de ${subcat}:`, err);
          }
        }
      }

      setRouteCoords(rutas);
      setLoadingRoute(false);
    };

    getRoutes();
  }, [destinos, categoriaSeleccionada]);

  if (destinos.length === 0) return null;

  return (
    <>
      {/* 📍 Marcadores de todos los destinos */}
      {destinos.map((d) => {
        const lat = parseFloat(d.latitud);
        const lng = parseFloat(d.longitud);
        if (isNaN(lat) || isNaN(lng)) return null;

        return (
          <Marker
            key={d.id}
            position={[lat, lng]}
            icon={getCategoryIcon(d.categoria)}
          />
        );
      })}

      {/* 🚗 Rutas solo para Circuitos Turísticos */}
      {categoriaSeleccionada === "Circuitos Turísticos" &&
        routeCoords.map((r, idx) => (
          <Polyline
            key={idx}
            positions={r.coords}
            pathOptions={{
              color: r.color,
              weight: 5,
              opacity: 0.8,
            }}
          />
        ))}
    </>
  );
};

export default PolygonLabels;
